// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"MenuShareCollection_iconContainer__NHrsU"};